/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppListEditsVideoEditorEditsQueryResponse, WebAppListEditsVideoEditorEditsQueryParams } from "../models/WebAppListEditsVideoEditorEdits";

export function getWebAppListEditsVideoEditorEditsUrl() {
  const res = { method: 'GET', url: `/web-app/v1/video-editor/edits` as const }
  return res
}

/**
 * @summary List edits for the client scoped to a fragment; each item includes creator, published platforms, and rendered video URL when a completed render exists
 * {@link /web-app/v1/video-editor/edits}
 */
export async function webAppListEditsVideoEditorEdits(params: WebAppListEditsVideoEditorEditsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppListEditsVideoEditorEditsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getWebAppListEditsVideoEditorEditsUrl().url.toString(), params, ... requestConfig })
  return res.data
}